import DialogActions from "./DialogActions";
import DialogActionButton from "./DialogActionButton";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

import { getOption } from "../../../lib/api/getOptions";

function DialogActionsOkCancel ( props ) {

    const { t } = useTranslation ();

    const { buttonDisabled, labels, onOk, onCancel, openProgress, ...others } = props;

    const [ replaceDialogActionButtonLabel, setReplaceDialogActionButtonLabel ] = useState ( true );

    useEffect ( () => {

        let mounted = true;

        ( async () => {

                let replaceDialogActionButtonLabel = await getOption ( "default", "replaceDialogActionButtonLabel" );

                if ( mounted ) {
                    
                    if ( replaceDialogActionButtonLabel.toLowerCase() === "true" ) {

                        setReplaceDialogActionButtonLabel ( true );
    
                    } else {
    
                        setReplaceDialogActionButtonLabel ( false );
    
                    }
    
                }

        } ) ();

        return ( () => {

            mounted = false;

        } );

    }, [] );

    const okButtonDisabled = () => {
        if(openProgress) {
            return true;
        }

        return buttonDisabled && buttonDisabled[0];
    }

    const cancelButtonDisabled = () => {
         if(openProgress) {
            return true;
        }

        return buttonDisabled && buttonDisabled[1];
    }

    return (
        <DialogActions {...others} >
            <DialogActionButton disabled={okButtonDisabled()} data-cy="OkButton" primary onClick={onOk} {...others}>{ ( replaceDialogActionButtonLabel && labels && labels[0] ) || t("common.ok")}</DialogActionButton>                    
            <DialogActionButton disabled={cancelButtonDisabled()} data-cy="CancelButton" onClick={onCancel} {...others}>{ ( replaceDialogActionButtonLabel && labels && labels[1] ) || t("common.cancel")}</DialogActionButton>                    
        </DialogActions>
    );

}

export default DialogActionsOkCancel;

